import { useSearchParams } from 'react-router'

import { REFERRAL_PARTNERS_SEARCH_PARAMS } from '../../../lib/services/routeService'

export function useReferralPartnersSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  return {
    params: searchParams,

    identifier:
      searchParams.get(REFERRAL_PARTNERS_SEARCH_PARAMS.identifier) || '',
    identifierType:
      searchParams.get(REFERRAL_PARTNERS_SEARCH_PARAMS.identifierType) || '',

    companyName:
      searchParams.get(REFERRAL_PARTNERS_SEARCH_PARAMS.companyName) || '',

    setCompanyName: (companyName: string) => {
      if (companyName) {
        searchParams.set(
          REFERRAL_PARTNERS_SEARCH_PARAMS.companyName,
          companyName,
        )
      } else {
        searchParams.delete(REFERRAL_PARTNERS_SEARCH_PARAMS.companyName)
      }

      setSearchParams(searchParams)
    },
  }
}
